import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import * as ResultsLive from '~/web-frontend-components/results/ResultsLive'

@inject('resultStore', 'dictStore')
@observer
class SelectDate extends Component{

    handleSelectDate = (id) => {
        this.props.resultStore.menu.setDate(id);
    }

    handleSelectDay = (e, picker) => {
        this.props.resultStore.menu.setDate(3, picker.startDate);
    }

    render() {

        const { getLang } = this.props.dictStore;
        const { resultDate } = this.props.resultStore.menu;

        return(
            this.props.data.map((el, idx) =>
                idx == 3 ?
                    <DateRangePicker key={idx} singleDatePicker maxDate={moment()} locale={ {format: 'YYYY-MM-DD', weekdaysShort: ['ВС','ПН','ВТ','СР','ЧТ','ПТ', 'СБ']} } onApply={this.handleSelectDay}>
                        <button className={`results-index-type datapicker ${resultDate == idx ? 'on' : ''}`}>
                            <span className=" f-s-ico-calendar"></span>
                        </button>
                    </DateRangePicker>
                :
                    <button key={idx} className={`results-index-date ${resultDate == idx ? 'on' : ''}`} onClick={() => this.handleSelectDate(idx)}>
                        { getLang(el) }
                    </button>
            )
        )
    }
}

@inject('resultStore', 'dictStore')
@observer
class SelectSport extends Component {
    componentDidMount() {
        const liveResults = this.props.resultStore.liveResults;
        liveResults.menu.subscribe(this.onupdate);
        if (this.props.resultStore.mode !== 'live') { return; }
        liveResults.listenWS();
    }

    componentWillUnmount() {
        const liveResults = this.props.resultStore.liveResults;
        liveResults.menu.unsubscribe(this.onupdate);
        liveResults.stopListenWS();
        liveResults.clear();
        this.props.resultStore.results.clear();
        this.props.resultStore.menu.clear();
    }

    onupdate = () => {
        this.setState({ upd: Date.now() });
    };

    getXHRdata() {
        const all = {
            hasMatches: true,
            name: 'ALL',
            id: 'all'
        };
        return {
            /** Есть ли матчи вообще. Определяет доступность кнопки «Все». */
            hasMatches: this.props.data.length !== 0,
            /** Данные по топ-спортам. */
            topSports: [all].concat(this.props.data.map((id) => ({
                hasMatches: !this.props.resultStore.menu.getDisabled(id),
                name: this.props.resultStore.menu.getDict(id),
                id,
            }))),
            /** Есть ли матчи по остальным видам спорта. Определяет доступность кнопки «Остальные». */
            otherSportsHasMatches: this.props.data.includes('other')
        };
    }

    loadSelected() {
        const isLiveMode = this.props.resultStore.mode === 'live';
        if (!isLiveMode) { return; }
        const liveResults = this.props.resultStore.liveResults;
        const selected = liveResults.menu.getSelected();
        if (selected.length === 0) { return; }
        liveResults.tables.listenWS({
            all: selected.includes('all'),
            others: selected.includes('other'),
            sportIds: selected.filter((id) => id !== 'all' && id !== 'other'),
        });
    }

    render() {
        const { getLang } = this.props.dictStore;
        const liveResults = this.props.resultStore.liveResults;
        const wssData = liveResults.menu.getData();
        const isLiveMode = this.props.resultStore.mode === 'live';
        const onSelect = (sportID, isSelected) => {
            (sportID === 'all') ?
                this.props.resultStore.menu.selectAll() :
                this.props.resultStore.menu.selectSport(sportID);

            liveResults.menu.select(sportID, isSelected);
            if (!isLiveMode) { return; }
            liveResults.tables.stopListenWS();
            liveResults.tables.clear();
            this.loadSelected();
        };

        if (isLiveMode && wssData) {
            return <ResultsLive.Menu
                isSelected={liveResults.menu.isSelected}
                select={onSelect}
                toLocale={getLang}
                data={wssData}
            />;
        }
        return <ResultsLive.Menu
            isSelected={liveResults.menu.isSelected}
            select={onSelect}
            toLocale={getLang}
            data={this.getXHRdata()}
        />;
    }
}

@inject('resultStore', 'dictStore')
@observer
export default class Filter extends Component{

    handleSelectType = (type) => {
        this.props.resultStore.menu.setType(type);
    }

    handleSelectMainScore = () => {
        this.props.resultStore.menu.setMainScore();
    }

    render() {

        const { menu, filter, type, resultDate, mainScore, store, label } = this.props.resultStore.menu;
        const { error } = this.props.resultStore;
        const { getLang } = this.props.dictStore;

        if (!this.props.resultStore.menu || !store) return false;

        if (store.mode == 'line' && filter) {
            return(
                <div className="results-index-menu">
                    <div className="">
                        <div className="results-index-info clearfix">
                            <h1 className="results-h1 fl_l">
                                { getLang('RESULTS') }  <span> { getLang(label) }</span>
                            </h1>
                            <div className="results-date-info fl_r">
                                <div className="results-index-menu-item ">
                                    <button className={`results-index-type results-main-score ${mainScore ? 'on' : ''}`} onClick={this.handleSelectMainScore}>
                                        { getLang('MAIN_SCORE') }
                                    </button>
                                </div>
                                <div className="results-index-menu-item ">
                                    {
                                        filter.type.map( (el, idx) =>
                                            <button key={idx} className={`results-index-type ${type == idx ? 'on' : ''}`} onClick={() => this.handleSelectType(idx)} >
                                                { getLang(el) }
                                            </button>
                                        )
                                     }
                                </div>
                                <div className="results-index-menu-item">
                                    <SelectDate data={filter.date}/>
                                </div>
                            </div>
                        </div>
                        <SelectSport data={menu.order} />
                    </div>
                </div>
            )
        } else if (store.mode == 'live') {
            return(
                <div className="results-index-menu">
                    <div className="">
                        <div className="results-index-info clearfix">
                            <h1 className="results-h1 fl_l">
                                { getLang('RESULTS') }
                            </h1>
                        </div>
                        <SelectSport data={menu.order} />
                    </div>
                </div>
            )
        } else {
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/results/filter.js